import { render, staticRenderFns } from "./Turno.vue?vue&type=template&id=ec372fcc&scoped=true&lang=pug&"
import script from "./Turno.vue?vue&type=script&lang=js&"
export * from "./Turno.vue?vue&type=script&lang=js&"
import style0 from "./Turno.vue?vue&type=style&index=0&id=ec372fcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec372fcc",
  null
  
)

export default component.exports